jQuery(document).ready(function() {
	
    // ******* Append query string parameters to leads-app.infousa.com hrefs ****************************************
    
    if (iusaEnvironment == 'DEV') {

        var appEnvironment = 'dev-leads-app.intra.infousa.com';

    } else if (iusaEnvironment == 'TEST') {

        var appEnvironment = 'test-leads-app.infousa.com';

    } else if (iusaEnvironment == 'PROD') {

        var appEnvironment = 'leads-app.infousa.com';

    } else {
        
        console.log('USA environment check is broken.');

    }
    
    mediacodeCookie = Cookies.get('mediacode');

    var appendParams = 'mediacode=' + (mediacodeCookie ? mediacodeCookie : '') + '&hubspotutk=' + Cookies.get('hubspotutk') + '&gclid=' + getParameterByName('gclid');

	jQuery('a[href*="' + appEnvironment + '"]').each(function() {

        var appLink = jQuery(this).attr('href');

        if (appLink.includes('?')) {

            var appLinkSeparator = '&';

        } else {

            var appLinkSeparator = '?';

        }

        var appLinkWithParams = appLink + appLinkSeparator + appendParams;        

        jQuery(this).attr('href', appLinkWithParams);
        
	});	
    
});